module.exports = __webpack_public_path__ + "img/baby-green.4e5d417f.svg";